import { render } from "./productProblem.vue?vue&type=template&id=2272bcca&scoped=true"
import script from "./productProblem.vue?vue&type=script&lang=js"
export * from "./productProblem.vue?vue&type=script&lang=js"

import "./productProblem.vue?vue&type=style&index=0&id=2272bcca&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2272bcca"]])

export default __exports__